import React, { useEffect, useState, useContext } from 'react';
import { getRoles, deleteRole } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css';
import RoleForm from './form';
import { Deletemodel, Pagination } from "../../Common/Functions";
import { useLocation, useNavigate } from 'react-router-dom';
import { isReadonlyRoute, NaviGate } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';

const parseMenuIds = (menuId) => {
  try {
    const parsed = typeof menuId === 'string' ? JSON.parse(menuId) : menuId;
    if (Array.isArray(parsed)) {
      return parsed.map(m => (m && typeof m === 'object' && m.menu) ? m.menu : m);
    }
    return [];
  } catch (e) {
    return [];
  }
};

const Role_list = () => {
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const [DeleteID, setDeleteID] = useState("")
  const [deletemodule, showdeletemodule] = useState(false)
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const rolesPerPage = 10;
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(WarehouseContext);


  useEffect(() => {
    fetchRoles(currentPage);
    var menus = [
      // {
      //   title: "Calender",
      //   route: '/calender'
      // },

      {
        title: "Warehouse",
        route: '/Warehouse_list'
      },
      {
        title: "Role",
        route: '/Role_list',
      },
      {
        title: "Users",
        route: '/User_list',
      },
      {
        title: "Customers",
        route: '/Customers_list',
      },
      {
        title: "Category",
        route: '/Category_list',
      },
      // {
      //   title: "SubCategory",
      //   route: '/Subcategory_list',
      // },
      {
        title: "Suppliers",
        route: '/Supplier_list',
      },
      {
        title: "Raw Metrial",
        route: '/raw_metrial',
      },
      {
        title: "Product",
        route: '/full_product',
      },
      {
        title: "Sales Order",
        route: '/product_order',
      },

      {
        title: "Manufacturer",
        route: '/Manufacturer_list',
      },
      {
        title: "Products",
        route: '/Product_list',
      },
      {
        title: "Product Quantity",
        route: '/ProductQty_list',
      },
      {
        title: "Purchase",
        route: '/purchase',
      },
      {
        title: "Purchase Order",
        route: '/purchase_order',
      },
      {
        title: "Quotation",
        route: '/Quotation_list',
      },
      {
        title: "Sales Window",
        route: '/sales_window',
      },
      {
        title: "Sales List",
        route: '/sales_list',
      },
      {
        title: "Finance Table",
        route: '/finance_list',
      },
      {
        title: "Units",
        route: '/units',
      },
      {
        title: "Taxes",
        route: '/taxes',
      },
      {
        title: "Document Type",
        route: '/documents_type',
      },
      {
        title: "Document Table",
        route: '/documents_table',
      },
      {
        title: "Document Details ",
        route: "/documents_details"
      },
      {
        title: "Credit Receipt",
        route: '/credit-receipt'
      },
      {
        title: "Invoice",
        route: '/invoice'
      },
      {
        title: "Find sales",
        route: "/findsale",
      },
      {
        title: "Accounts",
        route: "/accounts",
      },
      {
        title: "Services",
        route: "/services",
      },
      {
        title: "Service Expenses",
        route: "/service_expenses",
      },
      {
        title: "Expenses",
        route: "/expense",
      },
      {
        title: "Salary Management",
        route: "/salary_list",
      },
      {
        title: "Advance Report",
        route: "/advance_report",
      },
      // {
      //   title: "Client Feedback",
      //   route: "/Client_feedback",
      // },
      // {
      //   title: "Task Timer",
      //   route: "/task_timer",
      // },
    ];

    const enhancedMenuList = menus.map((menu) => ({
      ...menu,
      readonly: true
    }));

    setMenuList(enhancedMenuList);
  }, []);

  const handledeletemodel = (ID) => {
    showdeletemodule(true);
    setDeleteID(ID);
  }

  const fetchRoles = async (page = currentPage, text = "") => {
    showLoader();
    try {
      const response = await getRoles(page, text);
      console.log(response.data)
      setRoles(response.data.data);
      setTotalPages(response.data.pagination.total_pages);
      hideLoader();
    } catch (error) {
      console.error('Error fetching roles:', error);
      toast.error('Failed to fetch roles');
      hideLoader();
    }
  };

  const openModal = (role = null) => {
    setSelectedRole(role);
    console.log(role);
    setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteRole(DeleteID);
      toast.success('Role deleted successfully');
      fetchRoles();
      showdeletemodule(false);
    } catch (error) {
      console.error('Error deleting role:', error);
      toast.error('Error deleting role');
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchRoles(pageNumber);
  };

  const handleSearch = async (text) => {
    fetchRoles(1, text);
    setCurrentPage(1);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Roles List</h6>
          {!readonly && ( 
          <button
            type="button"
            onClick={() => openModal()}
            className="btn btn-primary mb-0">
            Add Role
          </button>
          )}
        </div>
        <hr className='mt-1' />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div className="d-flex position-relative" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  onChange={(e) => handleSearch(e.target.value)}
                />

                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table
                id="example"
                className="table table-striped table-sm table-bordered"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Role Title</th>
                    <th>Menu Title</th>
                   {!readonly && ( <th>Actions</th>)}
                  </tr>
                </thead>
                <tbody>
                  {roles.map((role, index) => (
                    <tr key={role.role_id}>
                      <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                      <td>{role.role_title}</td>
                      <td className='px-2 scrollhide' style={{ maxWidth: '200px', overflowX: 'scroll' }}>{JSON.stringify(menuList.filter(item => parseMenuIds(role?.menu_id).includes(item.route)).map(item => item.title).join(','))}</td>
                     {!readonly && (
                    <td>
                        {!(["Employee", "Manager", "Super Admin"].includes(role.role_title)) ? (
                          <>
                            <img
                              src='/assets/images/icons/edit.png'
                              onClick={() => openModal(role)}
                              height={"16px"}
                            />
                            <img
                              src='/assets/images/icons/delete.png'
                              className="mx-2"
                              onClick={() => handledeletemodel(role.role_id)}
                              height={"16px"}
                            />
                          </>
                        ) : (
                          <img
                            src='/assets/images/icons/edit.png'
                            onClick={() => openModal(role)}
                            height={"16px"}
                          />
                        )}
                      </td>
                       )} 
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {deletemodule && (
        <Deletemodel
          setShowModal={showdeletemodule}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <RoleForm
          selectedRole={selectedRole}
          setShowModal={setShowModal}
          fetchRoles={fetchRoles}
          menuList={menuList}
        />
      )}
    </div>

  )
}

export default Role_list;